import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PatientDataPassService {

  constructor() { }
  private currentID=new BehaviorSubject<String>(null);
  
 setID(current_id:string){
    this.currentID.next(current_id);

  }
  getID():Observable<String>{
    return this.currentID.asObservable();

  }
  resetID(){
    let temp=new BehaviorSubject<String>(null);
    this.currentID=temp;
  }
}
